import { Reveal } from "@/components/common/Reveal";

// Shared inner-page hero for Global pages.
export const PageHero = ({ eyebrow, title, lead, image }) => {
  return (
    <section className="relative overflow-hidden bg-azeka-navy pt-28 pb-16 sm:pt-32 sm:pb-20">
      {image && (
        <>
          <img
            src={image}
            alt=""
            aria-hidden="true"
            className="absolute inset-0 h-full w-full object-cover opacity-25"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-azeka-navy via-azeka-navy/90 to-azeka-navy/60" />
        </>
      )}
      <div className="grain absolute inset-0 opacity-40" />
      <div className="container-x relative">
        <Reveal className="max-w-3xl">
          <p className="eyebrow mb-4 text-azeka-teal2">{eyebrow}</p>
          <h1 className="text-4xl sm:text-5xl font-bold tracking-tight text-white leading-tight">
            {title}
          </h1>
          {lead && <p className="mt-6 text-lg leading-relaxed text-slate-300">{lead}</p>}
        </Reveal>
      </div>
    </section>
  );
};
